function setUserGenderBasedOnPage() {
    const currentURL = window.location.href.toLowerCase();
    
    if (currentURL.includes("women") || currentURL.includes("womens")) {
        localStorage.setItem("userGender", "women");
    } else if (currentURL.includes("men") || currentURL.includes("mens")) {
        console.log("men");
        localStorage.setItem("userGender", "men");
    }
}

setUserGenderBasedOnPage();